export function getStoreUrl (store) {
  let storeUrl = store.store_url;
  //console.log('---------', storeUrl, ' ------ ', store);

  if(store.slug === 'shopify' && store.slug.includes('https://') !== false){
    storeUrl = 'https://'+store.store_url;
  }
  return storeUrl;
}
